import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Card, Table, Tag, Button, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import axios from "../../../services/axiosConfig";
import Helper from "../../../services/Helper";
import { update } from "../../../store/features/orders/createSlice";
import { updateDiscountAmount } from "../../../store/features/orders/createSlice";

const OrderSummary = () => {
  const orderStoreDetails = useSelector((state) => state.order.orders);
  const dispatch = useDispatch();
  const [details, setDetails] = useState();
  const [availablePoint, setAvailablePoint] = useState(
    orderStoreDetails.points,
  );
  const [withGST, setWithGST] = useState(false);

  const columns = [
    {
      title: "Product",
      dataIndex: "category",
      render: (category) => category.name,
    },
    {
      title: "Varient",
      dataIndex: "attributs",
      render: (attributs) =>
        attributs &&
        attributs.length > 0 &&
        attributs.map((obj, i) => (
          <Tag color="#2db7f5" key={i}>
            {`${obj.Variant.name} : ${obj.name}`}
          </Tag>
        )),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
    },
    {
      title: `Total Point (${availablePoint})`,
      dataIndex: "category",
      render: (text, record, index) => (
        <Button
          type="primary"
          ghost
          style={{
            margin: "0 8px",
          }}
          disabled={availablePoint === 0 || availablePoint < 100 ? true : false}
          onClick={() => applypoints(index)}
        >
          Apply Points
        </Button>
      ),
    },
  ];

  useEffect(() => {
    try {
      (async () => {
        var data = await axios
          .post("/order-summary", { value: orderStoreDetails.orderDetails })
          .catch((error) => {
            Helper.ErrorHanlder(error);
          });

        if (data && data.data) {
          setDetails(data.data.data);

          let courierPrice = orderStoreDetails.courier;

          if (orderStoreDetails.courierType == "individual") {
            courierPrice = courierPrice * data?.data?.data?.[0]?.quantity;
          }

          if (
            orderStoreDetails.type === "courier" &&
            orderStoreDetails.address.states != "Tamil Nadu"
          ) {
            courierPrice = [
              "Kerala",
              "Telangana",
              "Karnataka",
              "Puducherry",
              "Andhra Pradesh",
            ].includes(orderStoreDetails.address.states)
              ? courierPrice * 1.7
              : courierPrice * 2.5;
          }

          dispatch(update({ courier: courierPrice }));

          if (
            data?.data?.data?.[0]?.category?.id ==
            "fdec4ed2-01c9-4b70-9920-e9f2817c6854"
          ) {
            dispatch(
              update({
                curentOrderPoints:
                  (_.sumBy(data?.data?.data, "total") / 100) * 2,
              }),
            );
          } else {
            dispatch(
              update({ curentOrderPoints: _.sumBy(data.data.data, "points") }),
            );
          }
        }
      })();
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
    // eslint-disable-next-line
  }, []);

  const applypoints = (index) => {
    if (availablePoint > 0) {
      let totalDiscountPrice;
      let newpoints;
      details.find((obj, i) => {
        if (i == index) {
          if (obj.total <= availablePoint) {
            newpoints = Number(availablePoint) - Number(obj.total);
            totalDiscountPrice = obj.total;
            obj.total = 0;
            setAvailablePoint(Number(newpoints).toFixed(2));
          } else {
            obj.total = Number(obj.total) - Number(availablePoint);
            totalDiscountPrice = availablePoint;
            setAvailablePoint(Number(0));
            newpoints = 0;
          }
        }
      });

      dispatch(
        update({
          points: Number(newpoints),
        }),
      );
      dispatch(
        updateDiscountAmount({
          index: index,
          total: Number(totalDiscountPrice),
        }),
      );
      setDetails([...details]);
    }
  };

  return (
    <Container fluid>
      <div className="order-details-pg mb-4">
        <Row>
          <Col md={12}>
            <Card
              title="Items"
              bordered={false}
              className="text-start"
              extra={
                window.location.pathname == "/create-custom-order" ? (
                  <>
                    <Button
                      type={withGST ? "primary" : "default"}
                      onClick={() => {
                        setWithGST(true);
                        dispatch(update({ gst: true }));
                      }}
                    >
                      With GST
                    </Button>
                    <Button
                      style={{ marginLeft: 8 }}
                      type={!withGST ? "primary" : "default"}
                      onClick={() => {
                        setWithGST(false);
                        dispatch(
                          update({
                            gst: false,
                          }),
                        );
                      }}
                    >
                      Without GST
                    </Button>
                  </>
                ) : null
              }
            >
              <Table
                columns={columns}
                dataSource={details}
                pagination={false}
                rowKey={(record, index) => index}
              />
            </Card>
          </Col>
          <Col md={6}>
            <Card
              title="Shipping Address"
              bordered={false}
              className="shipping-address"
            >
              {orderStoreDetails.address.name && (
                <>
                  <p>{orderStoreDetails.address.name}</p>
                  <p>{orderStoreDetails.address.address},</p>
                  <p>{orderStoreDetails.address.states},</p>
                  <p>
                    {orderStoreDetails.address.city}-
                    {orderStoreDetails.address.zip}
                  </p>
                  <p>Phone Number: +91 {orderStoreDetails.address.phone}</p>
                </>
              )}
            </Card>
          </Col>
          <Col md={3}>
            <Card
              title="Total Points"
              bordered={false}
              className="shipping-address"
            >
              <p className="total-points">
                {details?.[0]?.category?.id ==
                "fdec4ed2-01c9-4b70-9920-e9f2817c6854"
                  ? (_.sumBy(details, "total") / 100) * 2
                  : _.sumBy(details, "points")?.toFixed(0)}
              </p>
            </Card>
          </Col>
          <Col md={3}>
            <Card title="Order Summary" bordered={false}>
              <div className="order-summary">
                <div>
                  <p>SubTotal</p>
                  <p>Shipping</p>
                  <p className="total">Total</p>
                </div>
                <div>
                  <p>₹{_.sumBy(details, "total")}</p>
                  {orderStoreDetails.type == "courier" ? (
                    <p>₹{orderStoreDetails.courier}</p>
                  ) : (
                    <p>
                      <s>₹{orderStoreDetails.courier}</s>
                    </p>
                  )}
                  <p className="total">
                    ₹
                    {_.sumBy(details, "total") +
                      Number(
                        orderStoreDetails.type == "courier"
                          ? orderStoreDetails.courier
                          : 0,
                      )}
                  </p>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default OrderSummary;
